var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIgnore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24.0 23.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235,0 L1235,1164 L0,1164 L0,0 L1235,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.165387303,0.165411162 C0.38593526,-0.0551370538 0.743481675,-0.0551370538 0.964029632,0.165411162 L3.35998817,2.56140406 L5.7559467,0.165442713 C5.97649466,-0.0551055019 6.33404108,-0.0551055019 6.55458903,0.165442713 C6.77513699,0.385959377 6.77513699,0.743537764 6.55458903,0.964085979 L4.15866205,3.36001578 L6.55458903,5.75594557 C6.77513699,5.97649379 6.77513699,6.33404062 6.55458903,6.55458884 C6.33404108,6.77513705 5.97646311,6.77513705 5.7559467,6.55458884 L3.35998817,4.15862749 L0.964029632,6.55458884 C0.743481675,6.77513705 0.38593526,6.77513705 0.165387303,6.55458884 C-0.0551291011,6.33407218 -0.0551291011,5.97649379 0.165387303,5.75594557 L2.56134584,3.35998422 L0.165387303,0.964054427 C-0.0551291011,0.743537764 -0.0551291011,0.385959377 0.165387303,0.165411162 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-883.0 -446.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(860.0 206.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 82.00000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.0 159.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.92,0 C4.69424474,0 -1.0658141e-14,3.76950685 -1.0658141e-14,8.76879073 C-1.0658141e-14,13.7673627 4.69424474,17.5368696 10.92,17.5368696 C11.1245165,17.5368696 11.3250336,17.5259244 11.5261869,17.5155131 L11.5394578,17.5148902 L16.8387078,20.9461639 C16.8936091,20.981847 16.9571456,21 17.0206821,21 C17.0743108,21 17.1285759,20.9870081 17.177478,20.9611134 C17.2847356,20.9046967 17.3515443,20.7946219 17.3515443,20.6760045 L17.3515443,16.0603363 C20.2484071,14.5856717 21.84,12.0037628 21.84,8.76879073 C21.84,3.76950685 17.1457553,0 10.92,0 Z",
    stroke: "#636363",
    strokeWidth: 1.2,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.559999999999491 5.039999999999964)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.72,0 6.72,6.72 0,6.72 0,0",
    stroke: "none",
    fill: "#636363"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIgnore);
export default __webpack_public_path__ + "static/media/icIgnore.e5cffdbee898a79e58c95fc97af4c345.svg";
export { ForwardRef as ReactComponent };